export const canShowAble = (orgSettings, isSuperAdmin, isDriver) =>
  orgSettings?.enable_able === "true" && !isSuperAdmin && !isDriver;
